import React from 'react';
import { EventTextProps } from './EventText';
import { useSelector } from 'react-redux';
import { selectMatchEvents } from '../../features/match/matchSlice';
import { FormattedMessage } from 'react-intl';
import { getConnectedFouledEvent, getConnectedOffenceEvent } from '../../helpers/getConnectedEvent';

const EventTextPenalty: React.FC<EventTextProps> = ({ matchEvent }) => {
  const matchEvents = useSelector(selectMatchEvents);

  const team = matchEvent?.team?.name;
  const player = matchEvent?.person?.name;

  const offenceEvent = getConnectedOffenceEvent(matchEvents, matchEvent);
  const fouledEvent = getConnectedFouledEvent(matchEvents, matchEvent);

  const offencePlayerName = offenceEvent?.person?.name;
  const fouledPlayerName = fouledEvent?.person?.name;

  const messageValues = { team, player, offencePlayerName, fouledPlayerName };

  const justTeam = team && !player;

  if (offenceEvent && fouledEvent) {
    if (justTeam) {
      if (offencePlayerName && fouledPlayerName) {
        return <FormattedMessage id="eventText.penalty.TeamFouledOffence" values={messageValues} />;
      } else if (offencePlayerName) {
        return <FormattedMessage id="eventText.penalty.TeamOffence" values={messageValues} />;
      } else if (fouledPlayerName) {
        return <FormattedMessage id="eventText.penalty.TeamFouled" values={messageValues} />;
      } else {
        return <FormattedMessage id="eventText.penalty.Team" values={messageValues} />;
      }
    } else {
      if (offencePlayerName && fouledPlayerName) {
        return <FormattedMessage id="eventText.penalty.FouledOffence" values={messageValues} />;
      } else if (offencePlayerName) {
        return <FormattedMessage id="eventText.penalty.Offence" values={messageValues} />;
      } else if (fouledPlayerName) {
        return <FormattedMessage id="eventText.penalty.Fouled" values={messageValues} />;
      } else {
        return <FormattedMessage id="eventText.penalty" values={messageValues} />;
      }
    }
  } else if (offenceEvent) {
    if (justTeam) {
      if (offencePlayerName) {
        return <FormattedMessage id="eventText.penalty.TeamOffence" values={messageValues} />;
      } else {
        return <FormattedMessage id="eventText.penalty.Team" values={messageValues} />;
      }
    } else {
      if (offencePlayerName) {
        return <FormattedMessage id="eventText.penalty.Offence" values={messageValues} />;
      } else {
        return <FormattedMessage id="eventText.penalty" values={messageValues} />;
      }
    }
  } else if (fouledEvent) {
    if (justTeam) {
      if (fouledPlayerName) {
        return <FormattedMessage id="eventText.penalty.TeamFouled" values={messageValues} />;
      } else {
        return <FormattedMessage id="eventText.penalty.Team" values={messageValues} />;
      }
    } else {
      if (fouledPlayerName) {
        return <FormattedMessage id="eventText.penalty.Fouled" values={messageValues} />;
      } else {
        return <FormattedMessage id="eventText.penalty" values={messageValues} />;
      }
    }
  } else {
    if (justTeam) {
      return <FormattedMessage id="eventText.penalty.Team" values={messageValues} />;
    } else {
      return <FormattedMessage id="eventText.penalty" values={messageValues} />;
    }
  }
};

export default EventTextPenalty;
